import { cn } from "@eduviaos/ui-kit";

/** Bottom sheet on phones (< md). */
export const MOBILE_SHEET_CLASS = cn(
  "max-h-[min(88dvh,720px)] overflow-y-auto rounded-t-[1.75rem]",
);

/** Centred modal panel on md+ (pairs with SheetContent side="center"). */
export const DESKTOP_MODAL_SHEET_CLASS = cn(
  "max-h-[min(80vh,640px)] overflow-y-auto",
  "w-[min(calc(100vw-2rem),28rem)]",
  "lg:w-[min(calc(100vw-4rem),32rem)]",
);

/**
 * @deprecated Use `ResponsiveSheetContent` — CSS-only overrides cannot fix
 * bottom-sheet slide animations on desktop.
 */
export const RESPONSIVE_SHEET_CLASS = cn(MOBILE_SHEET_CLASS, DESKTOP_MODAL_SHEET_CLASS);
